import { create } from 'zustand';
import { mutative } from 'zustand-mutative';

import * as permissionApi from '@/apis/permission.api';
import * as roleApi from '@/apis/role.api';
import type { Permission, Role } from '@/models';

export const useRbacStore = create<{
  roles: Role[];
  permissions: Permission[];
}>()(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mutative((_set) => {
    return {
      roles: [],
      permissions: [],
    };
  }),
);

export function setRoles(roles: Role[]) {
  useRbacStore.setState(async (draft) => {
    draft.roles = roles;
  });
}

export function setPermissions(permissions: Permission[]) {
  useRbacStore.setState(async (draft) => {
    draft.permissions = permissions;
  });
}

export function fetchRoles() {
  return useRbacStore.getState().roles;
}

export function fetchPermissions() {
  return useRbacStore.getState().permissions;
}

export function fetchRbac() {
  roleApi
    .list()
    .then(setRoles)
    .catch((err) => {
      console.info('Failed to fetch roles', err);
    });
  permissionApi
    .list()
    .then(setPermissions)
    .catch((err) => {
      console.info('Failed to fetch permissions', err);
    });
}
